'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
require('./BlockList.css');
require('./HorizontalList.css');
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * List wrapper for blocklist items
 */
var BlockList = function BlockList(_ref) {
  var subtle = _ref.subtle,
    children = _ref.children;
  var blockListClassNames = (0, _classnames2.default)({
    'c-block-list': !subtle,
    'c-list-horizontal-subtle': subtle
  });
  return _react2.default.createElement('ul', {
    className: blockListClassNames
  }, children);
};
BlockList.propTypes = process.env.NODE_ENV !== "production" ? {
  /** If content needs to be subtle*/
  subtle: _propTypes2.default.bool,
  /** Children to display within the table */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
} : {};
exports.default = BlockList;